import { render, staticRenderFns } from "./CompChooseDialog.vue?vue&type=template&id=2174b43c&scoped=true"
import script from "./CompChooseDialog.vue?vue&type=script&lang=js"
export * from "./CompChooseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2174b43c",
  null
  
)

export default component.exports